module.exports = __webpack_public_path__ + "img/mousing.9f50b380.png";